<template>
    <AffiliateLandingPage
      imageExt="png"
      imageName="corestream"
      routePath="corestream"
      company="Corestream"
    ></AffiliateLandingPage>
  </template>
  
  <script>
  import AffiliateLandingPage from '@/components/Affiliate/AffiliateLandingPage.vue'
  
  export default {
    components: {
      AffiliateLandingPage
    },
    name: 'CorestreamLandingPage'
  }
  </script>
  
  <style></style>
  